module.exports = __webpack_public_path__ + "media/images/front/team/aziz_el_atiaqui-224bf85e6f06c8734b53b64abc695f33.jpg";